import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgListen = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 17" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#4D4D4D">
      <path d="M2.722 5.528C3.266 2.51 4.874 1 7.547 1 11.555 1 12 5.029 12 6.153c0 1.124-.944 2.965-1.973 4.053-.686.725-1.575 2.075-2.666 4.05C6.647 15.417 5.797 16 4.812 16 3.334 16 2 14.924 2 12.98" />
      <path d="M10 5.845C9.68 3.948 8.855 3 7.522 3c-1.333 0-2.18.658-2.54 1.975.058.846-.097 1.469-.464 1.868-.55.6-.818 1.261 0 1.75.818.489.93 1.3.465 1.822-.465.523-1.61 1.471.465 2.585" />
    </g>
  </svg>
);
const Memo = memo(SvgListen);
export default Memo;
